import React, { useEffect } from "react";
import { DialogActions } from "@material-ui/core";
import * as yup from "yup";
import Swal from "sweetalert2";
import AppForm from "../../../../../../partials/content/Forms/AppForm";
import VisitEditFormContent from "./visitEditFormContent";
import { updateSalesVisit } from "../../../../../../services/crm/salesJourney";
import store from "../../../../../../store/store";
import { setObject } from "../../../../../../utils/utils";
import { useGlobalData } from "../../../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
const visitSchema = yup.object().shape({
  ID: yup.number(),
  visitTo: yup.string().required("Visit To is Required"),
  customerID: yup.number(),
  leadID: yup.number(),
  salesCardID: yup.number(),
  salesCardTitle: yup.string(),
  planVisitDate: yup.date(),
  description: yup.string(),
});
function VisitEditForm({
  visit = {
    ID: 0,
    visitTo: "",
    customerID: 0,
    leadID: 0,
    salesCardID: 0,
    salesCardTitle: "",
    planVisitDate: DateTime.now().endOf("day"),
    description: "",
  },
  onCloseDialog,
  onConfirmSave,
}) {
  const { socket } = useGlobalData();
  useEffect(() => {
    const { auth } = store.getState();

    if (visit && visit.ID > 0) {
      setObject(socket, "lock", visit.ID, "VIST", auth.user)
        .then((response) => {})
        .catch((error) => {
          onCloseDialog();
        });
    }
    return () => {
      if (visit && visit.ID > 0) {
        setObject(socket, "release", visit.ID, "VIST", auth.user);
      }
    };
  }, [visit]);
  return (
    <AppForm
      initialValues={visit}
      validationSchema={visitSchema}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Visit ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              updateSalesVisit(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onConfirmSave();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
      headSubmitButton={false}
    >
      <VisitEditFormContent />
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={onCloseDialog}
        >
          <i className="fas fa-window-close"></i>
          Cancel
        </button>
        <button
          type="submit"
          className="btn btn-success btn-md btn-pill btn-bold"
        >
          <i className="fas fa-save"></i>
          Save
        </button>
      </DialogActions>
    </AppForm>
  );
}

export default VisitEditForm;
